/** Plays a recording through a short-lived signed URL (a <video> tag cannot send the bearer token itself). */
import { useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import { http } from "./api";
import { NotForDiagnosis, VideoFrame } from "./ui";

export function RecordingPlayer({ recordingId, token }: { recordingId: string; token: string }) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    http.get<{ url: string }>(token, `/recordings/${recordingId}/url`).then((r) => (r.ok ? setUrl(r.result.url) : setError(r.error)));
  }, [recordingId, token]);
  if (error) return <Typography color="error" variant="body2">{error}</Typography>;
  return url ? (
    <Stack spacing={0.75}>
      <VideoFrame glow="none">
        <video src={url} controls playsInline style={{ width: "100%", display: "block", background: "black" }} />
      </VideoFrame>
      <NotForDiagnosis />
    </Stack>
  ) : null;
}
